"use client";

import CodeText, { CodeTextType } from "@/app/(components)/generics/CodeText/CodeText";
import Collapsible from "@/app/(components)/generics/Collapsible/Collapsible";
import TabbedContent from "@/app/(components)/generics/TabbedContent/TabbedContent";
import { useT } from "@/app/translations/useT";
import { MCP_GUIDE_TOOL_GROUPS } from "../McpGuide.logic";
import styles from "./McpToolsTabs.module.css";

export default function McpToolsTabs() {
  const T = useT();

  const items = MCP_GUIDE_TOOL_GROUPS.map((group) => ({
    id: group.titleKey,
    title: T(group.titleKey),
    content: (
      <div className={styles.tools}>
        {group.tools.map((tool) => (
          <Collapsible
            key={tool.labelKey}
            containerClassName={styles.tool}
            trigger={<span className={styles.toolLabel}>{T(tool.labelKey)}</span>}
            content={
              <div className={styles.response}>
                <CodeText type={CodeTextType.BLOCK} text={tool.response} border={false} />
              </div>
            }
          />
        ))}
      </div>
    ),
  }));

  return <TabbedContent items={items} hideContentPadding={true} disableScrollOnTabChange={true} />;
}
